import { empty } from 'patronum';
import { createAccountTransactionRegistryModel } from 'entities/transaction';
import { accountPageModel } from './account-page-model';

const accountTransactionRegistryModel = createAccountTransactionRegistryModel({
	$accountId: accountPageModel.$accountId,
	disabled: empty(accountPageModel.$accountId),
	onUpdate: [accountPageModel.$accountId],
});

export const accountPageTransactionsModel = {
	accountTransactionRegistryModel,
};
